import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const getOptionBackgroundColor = ({ isFocused, isSelected }) => {
  if (isSelected) {
    return '#3e3e3e'
  }

  if (isFocused) {
    return '#383838'
  }

  return '#2a2a2a'
}

const { unit } = measures

export const select = {
  // Add more comprehensive styling for the select component
  container: (provided) => ({
    ...provided,
    width: '180px',
  }),
  control: (state) => {
    if (state.isDisabled) {
      return { backgroundColor: 'transparent' }
    }

    return {
      backgroundColor: '#2a2a2a',
      borderColor: '#3e3e3e',
      minHeight: '40px',
      height: '40px',
      boxShadow: 'none',
      borderRadius: '4px',
      '&:hover': {
        borderColor: '#4a4a4a'
      }
    };
  },
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#2a2a2a',
    zIndex: 99999,
  }),
  option: (provided, { isFocused, isSelected }) => ({
    ...provided,
    backgroundColor: getOptionBackgroundColor({ isFocused, isSelected }),
    color: '#ffffff',
  }),
  indicatorsContainer: (state) => {
    if (state.isDisabled) {
      return { display: 'none' }
    }
  },
}

export const control = css`
  &:disabled {
    background-color: transparent;
  }
`

export const row = css`
  display: flex;
  align-items: center;
  min-height: ${8 * unit}px;
  ${MQ.PHONES} {
    justify-content: space-between;
  }

  & label {
    min-width: ${14 * unit}px;
    margin-bottom: ${2 * unit}px;
  }
`
